/**
 * @generated SignedSource<<3ec14e8b12199a0c105ee299fc803013>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastFocusBottomSheetQuery$variables = {
  id: string;
};
export type StorecastFocusBottomSheetQuery$data = {
  readonly dashboard: {
    readonly id: string;
    readonly name: string;
    readonly screens: ReadonlyArray<{
      readonly activeSession: {
        readonly id: string;
      } | null;
      readonly id: string;
      readonly name: string;
    }>;
    readonly temporaryScreen: {
      readonly id: string;
    } | null;
  };
  readonly storecast: {
    readonly screens: ReadonlyArray<{
      readonly activeSession: {
        readonly id: string;
      } | null;
      readonly dashboard: {
        readonly id: string;
      } | null;
      readonly id: string;
      readonly name: string;
    }>;
  };
};
export type StorecastFocusBottomSheetQuery = {
  response: StorecastFocusBottomSheetQuery$data;
  variables: StorecastFocusBottomSheetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v1/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "StorecastSession",
  "kind": "LinkedField",
  "name": "activeSession",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Storecast",
  "kind": "LinkedField",
  "name": "storecast",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StorecastScreen",
      "kind": "LinkedField",
      "name": "screens",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "dashboard",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ],
  "concreteType": "Dashboard",
  "kind": "LinkedField",
  "name": "dashboard",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StorecastScreen",
      "kind": "LinkedField",
      "name": "screens",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StorecastScreen",
      "kind": "LinkedField",
      "name": "temporaryScreen",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastFocusBottomSheetQuery",
    "selections": [
      (v5/*: any*/),
      {
        "kind": "RequiredField",
        "field": (v6/*: any*/),
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StorecastFocusBottomSheetQuery",
    "selections": [
      (v5/*: any*/),
      (v6/*: any*/)
    ]
  },
  "params": {
    "cacheID": "a7a532be623e9329afcdea1b6be38e2e",
    "id": null,
    "metadata": {},
    "name": "StorecastFocusBottomSheetQuery",
    "operationKind": "query",
    "text": "query StorecastFocusBottomSheetQuery(\n  $id: ID!\n) {\n  storecast {\n    screens {\n      id\n      name\n      activeSession {\n        id\n      }\n      dashboard {\n        id\n      }\n    }\n  }\n  dashboard(id: $id) {\n    id\n    name\n    screens {\n      id\n      name\n      activeSession {\n        id\n      }\n    }\n    temporaryScreen {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "595719876f7b7b12d15bf4c3756deb1e";

export default node;
